@if (open()) {
  <div class="scrim" aria-hidden="true"></div>
  <section class="sheet" role="dialog" aria-modal="true" [attr.aria-label]="label()">
    <ng-content></ng-content>
  </section>
}